<template>
  <b-card header="Statistics">
    <div class="alert newport-page-header" role="alert" style="margin-bottom:0px;">
      <div>
        <b-dropdown id="ddown1" :text="selectedYear" class="m-md-2" variant="primary">
          <b-dropdown-item v-on:click="selectYear(i);" v-model="selectedYear" v-for="i in years" :key="i">{{i}}</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <b-row>
    <b-col cols="12" md="4">
    <table class="table table-sm">
      <thead>
        <tr>
          <th scope="col" colspan="4" style="background-color:rgb(51, 103, 103); color:white;">Lock</th>
        </tr>
        <tr>
          <th scope="col">Month</th>
          <th scope="col">Success</th>
          <th scope="col">Failed</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="history in histories" :key="history.MONTH" :monthName="getMonthName(history.MONTH)">
          <th scope="row">{{(new Date(history.DATE_VAL)).toLocaleString('en-GB', {month: 'short'})}}</th>
          <td class="table-success" v-if="history.TOTAL_SUCCESS > 0"><strong>{{history.TOTAL_SUCCESS}}</strong></td>
          <td class="table-success" v-if="history.TOTAL_SUCCESS == 0">{{history.TOTAL_SUCCESS}}</td>
          <td class="table-danger" v-if="history.TOTAL_FAILED > 0"><strong>{{history.TOTAL_FAILED}}</strong></td>
          <td class="table-danger" v-if="history.TOTAL_FAILED == 0">{{history.TOTAL_FAILED}}</td>
        </tr>
      </tbody>
      </table>
      </b-col>

      <b-col cols="12" md="4">
      <table class="table table-sm">
        <thead>
          <tr>
            <th scope="col" colspan="4" style="background-color:rgb(51, 103, 103); color:white;">Unlock</th>
          </tr>
          <tr>
            <th scope="col">Month</th>
            <th scope="col">Success</th>
            <th scope="col">Failed</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="history in historiesEleven" :key="history.MONTH" :monthName="getMonthName(history.MONTH)">
            <th scope="row">{{(new Date(history.DATE_VAL)).toLocaleString('en-GB', {month: 'short'})}}</th>
            <td class="table-success" v-if="history.TOTAL_SUCCESS > 0"><strong>{{history.TOTAL_SUCCESS}}</strong></td>
            <td class="table-success" v-if="history.TOTAL_SUCCESS == 0">{{history.TOTAL_SUCCESS}}</td>
            <td class="table-danger" v-if="history.TOTAL_FAILED > 0"><strong>{{history.TOTAL_FAILED}}</strong></td>
            <td class="table-danger" v-if="history.TOTAL_FAILED == 0">{{history.TOTAL_FAILED}}</td>
          </tr>
        </tbody>
        </table>
        </b-col>

      <b-col cols="12" md="4">
      <table class="table table-sm">
        <thead>
          <tr>
            <th scope="col" colspan="4" style="background-color:rgb(51, 103, 103); color:white;">Passcode unlock</th>
          </tr>
          <tr>
            <th scope="col">Month</th>
            <th scope="col">Success</th>
            <th scope="col">Failed</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="history in historiesFour" :key="history.MONTH" :monthName="getMonthName(history.MONTH)">
            <th scope="row">{{(new Date(history.DATE_VAL)).toLocaleString('en-GB', {month: 'short'})}}</th>
            <td class="table-success" v-if="history.TOTAL_SUCCESS > 0"><strong>{{history.TOTAL_SUCCESS}}</strong></td>
            <td class="table-success" v-if="history.TOTAL_SUCCESS == 0">{{history.TOTAL_SUCCESS}}</td>
            <td class="table-danger" v-if="history.TOTAL_FAILED > 0"><strong>{{history.TOTAL_FAILED}}</strong></td>
            <td class="table-danger" v-if="history.TOTAL_FAILED == 0">{{history.TOTAL_FAILED}}</td>
          </tr>
        </tbody>
        </table>
        </b-col>

      <b-col cols="12" md="4">
        <table class="table table-sm">
          <thead>
            <tr>
              <th scope="col" colspan="4" style="background-color:rgb(51, 103, 103); color:white;">Delete Passcode</th>
            </tr>
            <tr>
              <th scope="col">Month</th>
              <th scope="col">Success</th>
              <th scope="col">Failed</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="history in historiesSix" :key="history.MONTH" :monthName="getMonthName(history.MONTH)">
              <th scope="row">{{(new Date(history.DATE_VAL)).toLocaleString('en-GB', {month: 'short'})}}</th>
              <td class="table-success" v-if="history.TOTAL_SUCCESS > 0"><strong>{{history.TOTAL_SUCCESS}}</strong></td>
              <td class="table-success" v-if="history.TOTAL_SUCCESS == 0">{{history.TOTAL_SUCCESS}}</td>
              <td class="table-danger" v-if="history.TOTAL_FAILED > 0"><strong>{{history.TOTAL_FAILED}}</strong></td>
              <td class="table-danger" v-if="history.TOTAL_FAILED == 0">{{history.TOTAL_FAILED}}</td>
            </tr>
          </tbody>
          </table>
        </b-col>
    <!-- </b-row> -->

    <!-- 2nd row tables stats -->
    <!-- <b-row> -->
      <b-col cols="12" md="4">
      <table class="table table-sm">
        <thead>
          <tr>
            <th scope="col" colspan="3" style="background-color:rgb(51, 103, 103); color:white;">Create Passcodes</th>
          </tr>
          <tr>
            <th scope="col">Month</th>
            <th scope="col">Created passcodes</th>
            <th scope="col">Deleted passcodes</th>
          </tr>
        </thead>
        <tbody>
        <!-- loop begin -->
          <tr  v-for="passcode in passcodes" :key="passcode.MONTH"  :monthName="getMonthName(passcode.MONTH)">
            <th scope="row">{{(new Date(passcode.DATE_VAL)).toLocaleString('en-GB', {month: 'short'})}}</th>
            <td  class="table-success" v-if="passcode.created_passcode > 0"><strong>{{passcode.created_passcode}}</strong></td>
            <td  class="table-success" v-if="passcode.created_passcode == 0">{{passcode.created_passcode}}</td>
            <td  class="table-danger" v-if="passcode.deleted_passcode > 0"><strong>{{passcode.deleted_passcode}}</strong></td>
            <td  class="table-danger" v-if="passcode.deleted_passcode == 0">{{passcode.deleted_passcode}}</td>
          </tr>
        </tbody>
        <!-- loop end -->
        </table>
        </b-col>

        <b-col cols="12" md="4">
          <table class="table table-sm">
            <thead>
              <tr>
                <th scope="col" colspan="2" style="background-color:rgb(51, 103, 103); color:white;">Create Keys</th>
              </tr>
              <tr>
                <th scope="col">Month</th>
                <th scope="col">Created keys</th>
              </tr>
            </thead>
            <tbody>
            <!-- loop begin -->
              <tr v-for="key in keyscreated" :key="key.MONTH"  :monthName="getMonthName(key.MONTH)">
                <th scope="row">{{(new Date(key.DATE_VAL)).toLocaleString('en-GB', {month: 'short'})}}</th>
                <td v-if="key.created_keys > 0" class="table-success"><strong>{{key.created_keys}}</strong></td>
                <td v-if="key.created_keys == 0" class="table-danger">{{key.created_keys}}</td>
              </tr>
            </tbody>
            <!-- loop end -->
            </table>
          </b-col>
    </b-row>
  </b-card>
</template>

<script>
let qs = require('qs')
const constants = require('../shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API_HISTORY_STATS = BASE + '/api/statistics/history'
const API_CREATED_KEYS_STATS = BASE + '/api/statistics/keysCreated'
const API_PASSCODES_STATS = BASE + '/api/statistics/passcode'
const API_PASSCODES_FOR_LOCK_STATS = BASE + '/api/statistics/passcodeForLock'

var dateOptions = {month: 'short'}

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'accessToken': data.accessToken
    },
    method: 'POST'
  })
    .then(res => res.json())
}

async function getDataHistory (recordType, selectedYear) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    locationId: localStorage.getItem('locationId'),
    ownerId: localStorage.getItem('owid'),
    recordType: recordType,
    selectedYear: selectedYear
  }
  let res = await postdata(API_HISTORY_STATS, parameters)
  return res
}

async function getDataKeysCreated (selectedYear) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    locationId: localStorage.getItem('locationId'),
    ownerId: localStorage.getItem('owid'),
    selectedYear: selectedYear
  }
  let res = await postdata(API_CREATED_KEYS_STATS, parameters)
  return res
}

async function getDataPasscode (selectedYear) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    locationId: localStorage.getItem('locationId'),
    ownerId: localStorage.getItem('owid'),
    selectedYear: selectedYear
  }
  let res = await postdata(API_PASSCODES_STATS, parameters)
  return res
}

async function getDataPasscodeForLock () {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    locationId: localStorage.getItem('locationId'),
    ownerId: localStorage.getItem('owid')
  }
  let res = await postdata(API_PASSCODES_FOR_LOCK_STATS, parameters)
  return res
}

export default {
  name: 'statistics',
  props: ['locationName', 'locationDescription'],
  data: () => {
    return {
      years: [],
      selectedYear: '',
      histories: [],
      historiesFour: [],
      historiesSix: [],
      historiesEleven: [],
      keyscreated: [],
      passcodes: [],
      pfls: [],
      recordsTypes: [
        '-',
        'App unlock',
        'touch the parking lock',
        'gateway unlock',
        'passcode unlock',
        'parking lock raise',
        'parking lock lower',
        'IC card unlock',
        'fingerprint unlock',
        'wristband unlock',
        'mechanical key unlock',
        'Bluetooth lock',
        'gateway unlock',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
        '24',
        '25',
        '26',
        '27',
        '28',
        'unexpected unlock',
        'door magnet close',
        'door magnet open'
      ],
      currentPage: 1,
      perPage: 15,
      totalRows: 0,
      filter: null
    }
  },
  mounted () {
    var year = new Date()
    for (var i = year.getFullYear(); i > (year.getFullYear() - 5); --i) {
      if (i >= 2018) {
        this.$data.years.push(i)
      }
    }
    getDataHistory(1, year.getFullYear()).then(response => {
      this.$data.histories = response.result
      this.$data.selectedYear = response.selectedYear
    })
    getDataHistory(11, year.getFullYear()).then(response => {
      this.$data.historiesEleven = response.result
      this.$data.selectedYear = response.selectedYear
    })
    getDataHistory(4, year.getFullYear()).then(response => {
      this.$data.historiesFour = response.result
    })
    getDataHistory(6).then(response => {
      this.$data.historiesSix = response.result
    })
    getDataKeysCreated(year.getFullYear()).then(response => {
      this.$data.keyscreated = response.result
    })
    getDataPasscode(year.getFullYear()).then(response => {
      this.$data.passcodes = response.result
    })
    getDataPasscodeForLock(year.getFullYear()).then(response => {
      this.$data.pfls = response.result
    })
  },
  methods: {
    mailto (email) {
      return 'mailto:' + email
    },
    getRowCount (items) {
      return items.length
    },
    openlink (link) {
      location.href = link
    },
    getMonthName (aVal) {
      var d = new Date()
      d.setMonth(aVal - 1)
      let formatted = (d).toLocaleString('en-GB', dateOptions)
      return formatted
    },
    selectYear (aYear) {
      this.selectedYear = aYear
      getDataHistory(1, aYear).then(response => {
        this.histories = response.result
        this.selectedYear = response.selectedYear
      })
      getDataHistory(11, aYear).then(response => {
        this.historiesEleven = response.result
        this.selectedYear = response.selectedYear
      })
      getDataHistory(4, aYear).then(response => {
        this.historiesFour = response.result
      })
      getDataHistory(6, aYear).then(response => {
        this.historiesSix = response.result
      })
      getDataKeysCreated(aYear).then(response => {
        this.keyscreated = response.result
      })
      getDataPasscode(aYear).then(response => {
        this.passcodes = response.result
      })
      getDataPasscodeForLock(aYear).then(response => {
        this.pfls = response.result
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/haus/Statistics.vue